import React, { useState } from "react";
import HomeScreen from "../HomeScreen";
import QuizScreen from "../QuizScreen";
import ResultScreen from "../ResultScreen";
import TutorialScreen from "../TutorialScreen";

const RouterScreen = () => {
  const [currentScreen, setCurrentScreen] = useState("Home");
  const [answers, setAnswers] = useState([])

  return (
    <>
      {currentScreen === "Home" && (
        <HomeScreen setCurrentScreen={setCurrentScreen} />
      )}
      {/* {currentScreen === "Tutorial" && <TutorialScreen setCurrentScreen={setCurrentScreen} />} */}
      {currentScreen === "Quiz" && <QuizScreen setCurrentScreen={setCurrentScreen} givenAnswers={answers} setGivenAnswers={setAnswers} />}
      {currentScreen === "Result" && <ResultScreen  setCurrentScreen={setCurrentScreen} answers={answers} setAnswers={setAnswers} />}
    </>
  );
};

export default RouterScreen;
